import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MerchantLifecycleRepository } from '@app/domain/ports/tpv/merchant-lifecycle.repository';
import { UpdateMerchantRequest } from '@app/data/dtos/tpv/merchant-update.dto';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope, unwrapTpv } from '@app/data/tpv/tpv-envelope';

/**
 * Implementación HTTP del ciclo de vida de comercios (§3).
 *
 * Auth: NO setea cabeceras manuales. El `authInterceptor` agrega el Bearer y
 * maneja 401/refresh; el `ApiKeyInterceptor` agrega el `x-api-key`. Estos
 * endpoints no requieren `Idempotency-Key`.
 */
@Injectable()
export class MerchantLifecycleRemoteDataSource extends MerchantLifecycleRepository {
  private readonly http = inject(HttpClient);

  override updateMerchant(
    externalIdMerchant: string,
    payload: UpdateMerchantRequest,
  ): Observable<void> {
    return this.http
      .patch<TpvEnvelope<unknown>>(tpvUrl(`merchants/${externalIdMerchant}/`), payload)
      .pipe(map(() => void 0));
  }

  override deleteMerchant(externalIdMerchant: string): Observable<void> {
    return this.http
      .delete<TpvEnvelope<unknown>>(tpvUrl(`merchants/${externalIdMerchant}/`))
      .pipe(map(() => void 0));
  }

  override activateMerchant(externalIdMerchant: string): Observable<Record<string, unknown> | null> {
    return this.http
      .post<TpvEnvelope<unknown>>(tpvUrl(`merchants/${externalIdMerchant}/activate/`), {})
      .pipe(
        map((raw) => {
          const data = unwrapTpv<unknown>(raw);
          return data && typeof data === 'object' ? (data as Record<string, unknown>) : null;
        }),
      );
  }
}
